<ng-payment-tender
  [parentForm]="paymentTender"
  [tableData]="tableData"
  [selectedProducts]="selectedProducts"
  [tableCols]="tableCols"
  [knetcols]="knetcols"
  [knetTableData]="knetTableData"
  [knetSelectedData]="knetSelectedData"
  [tableRowDisabled]="tableRowDisabled"
  [knetTableRowDisabled]="knetTableRowDisabled"
  [externalProvideToggle]="externalProvideToggle"
  [arrowIconS]="arrowIconS"
  [disabledAllEvent]="editScreen"
  (TableRowSelect)="TableRowSelect($event)"
  (TableRowUnSelect)="TableRowUnSelect($event)"
  (TableAllRowSelect)="TableAllRowSelect($event)"
  (knetTableRowSelect)="knetTableRowSelect($event)"
  (knetTableRowUnSelect)="knetTableRowUnSelect($event)"
  (knetTableAllRowSelect)="knetTableAllRowSelect($event)"
  (knetRowReorder)="knetRowReorder($event)"
  (rowReorder)="rowReorder($event)"
></ng-payment-tender>
